import { defineElement } from "domvm";
import { i18n } from "../../lib/globalization/i18n";
import { Module } from "../../lib/ui/Module";
import { Services } from "../../lib/services/Services";

export class HelloPage extends Module {

    _render(vm) {

        const ct = Services.get('templates');

        return ct.module([
            ct.h1([
                i18n.t('pages.hello_page.title')
            ])
        ]);

    };

}